import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Card } from 'antd';
import { useAppTheme } from '../../theme/ThemeProvider';

interface ComingSoonProps {
  height?: number | string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ height = 260 }) => {
  const { t } = useTranslation();
  const { theme } = useAppTheme();
  return (
    <Card
      size="small"
      style={{
        background: theme.toolbarBackground,
        border: `1px dashed ${theme.surfaceBorder}`,
        borderRadius: 8
      }}
      bodyStyle={{ padding: 16 }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height,
        }}
      >
        <Alert
          type="info"
          message={t('feature.comingSoon.title')}
          description={t('feature.comingSoon.subtitle')}
          showIcon
          style={{
            background: theme.surfaceBackground,
            border: `1px solid ${theme.surfaceBorder}`,
            color: theme.textPrimary,
          }}
        />
      </div>
    </Card>
  );
};

export default ComingSoon;


